import {Controller} from '@hotwired/stimulus';

/**
 * Formulaire de configuration d'une mise à jour de widget (« Mes widgets »), ouvert en fenêtre fancybox : l'envoie
 * sans quitter la fenêtre, puis recharge la page qui l'a ouverte, où le résultat de la mise à jour s'affiche.
 *
 *   {{ form_start(form, {attr: (stimulus_controller('widgets--update-configurator')|stimulus_action('widgets--update-configurator', 'submit', 'submit')).toArray()}) }}
 */
export default class extends Controller {
  async submit(event) {
    event.preventDefault();

    const form = this.element;

    try {
      await fetch(form.action, {method: form.method, body: new FormData(form)});
    } finally {
      window.parent.location.reload();
    }
  }
}
